import StyledLoader from 'components/Elements/StyledLoader'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import axiosClient from 'services/axios-client'
import { ForgotPasswordVerificationContainer } from './style'

function ForgotPasswordVerification() {
  const history = useHistory()
  const { t } = useTranslation()
  const [email, setEmail] = useState('')
  const [verificationCode, setVerificationCode] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)

  const validated = () => {
    const emailReg =
      /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i
    const passwordReg =
      /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[a-zA-Z!#$%&? "])[a-zA-Z0-9!#$%&?]{8,20}$/

    if (!verificationCode || verificationCode.trim().length === 0) {
      setError(t('required_field'))
      return false
    }

    if (!email || email.trim().length === 0 || !emailReg.test(email)) {
      setError(t('email_must_valid'))
      return false
    }

    if (
      !newPassword ||
      newPassword.trim().length === 0 ||
      !passwordReg.test(newPassword)
    ) {
      setError(t('invalid_password'))
      return false
    }

    return true
  }

  const passwordVerificationHandler = async () => {
    setError(null)

    if (validated()) {
      setLoading(true)
      try {
        const res = await axiosClient.post('/reset-password', {
          email,
          verificationCode,
          newPassword,
        })
        if (res.ok) {
          history.push('/login')
        }

        setLoading(false)
      } catch (err) {
        console.log(err)
        setError(err.message)
        setLoading(false)
      }
    }
  }

  if (loading) {
    return <StyledLoader />
  }

  return (
    <ForgotPasswordVerificationContainer>
      <div className="wrapper">
        <h4>{t('set_new_password')}</h4>
        <h6>{t('set_new_password_narration')}</h6>

        <div>
          <input
            type="text"
            className="input"
            id="verificationcode"
            aria-describedby="verificationCodeHelp"
            placeholder={t('enter_verification_code')}
            value={verificationCode}
            onChange={(evt) => setVerificationCode(evt.target.value)}
          />
          <input
            className="input"
            type="email"
            id="email"
            aria-describedby="emailHelp"
            placeholder={t('enter_email')}
            value={email}
            onChange={(evt) => setEmail(evt.target.value)}
          />
          <input
            type="password"
            className="input"
            id="newpassword"
            placeholder={t('new_password')}
            value={newPassword}
            onChange={(evt) => setNewPassword(evt.target.value)}
          />
          {error && <span className="error">{error}</span>}
          <button
            className="btn btn-submit"
            onClick={passwordVerificationHandler}
          >
            {t('submit')}
          </button>
        </div>
      </div>
    </ForgotPasswordVerificationContainer>
  )
}

export default ForgotPasswordVerification
